module.exports = __webpack_public_path__ + "static/media/header_code.96866faf.jpg";